var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable max-len */
import * as React from "react";
import { Div } from "../../../../03-base/Div";
import { Grid } from "../../../../03-base/Grid";
import { FieldSet } from "../../../../06-molecules/FieldSet";
import * as Forms from "../../../../07-organisms/Form/index";
import * as I18n from "../../../../../../utils/translations/I18n";
import { LogoutButton } from "./LogoutButton";
/**
 *
 */
var General = /** @class */ (function (_super) {
    __extends(General, _super);
    /**
     *
     * @param props
     * @param ctx
     */
    function General(props) {
        return _super.call(this, props) || this;
    }
    /**
     *
     */
    General.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        return (React.createElement(React.Fragment, null,
            React.createElement(FieldSet, { title: (_a = I18n.getText("mary.09-views.03-modals.accountsettings.tabs.general-information-title", "Information")) !== null && _a !== void 0 ? _a : "" },
                React.createElement(Div, { className: "scl-b-row" },
                    React.createElement(Grid, { size: { xs: 12, md: 6 } },
                        React.createElement(Forms.FormField, { label: typeof ((_b = this.props.user) === null || _b === void 0 ? void 0 : _b.name) === "string" ?
                                I18n.getText("mary.09-views.03-modals.accountsettings.tabs.general-user-name-label", "Username") : (_d = (_c = this.props.user) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.label, value: typeof ((_e = this.props.user) === null || _e === void 0 ? void 0 : _e.name) === "string"
                                ? (_f = this.props.user) === null || _f === void 0 ? void 0 : _f.name : (_h = (_g = this.props.user) === null || _g === void 0 ? void 0 : _g.name) === null || _h === void 0 ? void 0 : _h.value, asSummary: true }))),
                ((_j = this.props.user) === null || _j === void 0 ? void 0 : _j.subtitle) &&
                    React.createElement(Div, { className: "scl-b-row" },
                        React.createElement(Grid, { size: { xs: 12, md: 6 } },
                            React.createElement(Forms.FormField, { label: typeof ((_k = this.props.user) === null || _k === void 0 ? void 0 : _k.subtitle) === "string" ?
                                    I18n.getText("mary.09-views.03-modals.accountsettings.tabs.general-role-label", "Role") : (_m = (_l = this.props.user) === null || _l === void 0 ? void 0 : _l.subtitle) === null || _m === void 0 ? void 0 : _m.label, value: typeof ((_o = this.props.user) === null || _o === void 0 ? void 0 : _o.subtitle) === "string"
                                    ? (_p = this.props.user) === null || _p === void 0 ? void 0 : _p.subtitle : (_r = (_q = this.props.user) === null || _q === void 0 ? void 0 : _q.subtitle) === null || _r === void 0 ? void 0 : _r.value, asSummary: true })))),
            React.createElement(FieldSet, { title: (_s = I18n.getText("mary.09-views.03-modals.accountsettings.tabs.general-session-title", "Session")) !== null && _s !== void 0 ? _s : "" },
                React.createElement(LogoutButton, { allDevices: false, signOut: this.props.onLogout }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(LogoutButton, { allDevices: true, signOut: this.props.onLogout }))));
    };
    return General;
}(React.Component));
export { General };
